import React from "react"

import { Box, Chip, Typography, styled } from "@mui/material"
import FolderIcon from '@mui/icons-material/Folder';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

const CustomChip = styled(Chip)({
    borderRadius: '4px',
    height: '20px',
    width: '35px',
    '& .MuiChip-label': {
        paddingLeft: 0,
        paddingRight: 0
    }
});

export const TestingProgressIndicator = ({label, color, onClick}: {label: string, color: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning', onClick?: (event: React.MouseEvent) => void}) => {
    return <CustomChip label={label} color={color} onClick={onClick} clickable={!!onClick}
        onMouseDown={onClick && ((event) => event.stopPropagation())} />
}

export const FolderLabel = ({labelText, labelVariant='large', passed, warnings, errors, info, color, noicon, alternateIcon, onChipClick}: {
        labelText: string | null, 
        noicon?: boolean,
        alternateIcon?: number,
        labelVariant?: 'large' | 'small'
        color?: 'inherit' | 'error' | 'info' | 'success' | 'warning',
        passed?: number, warnings?: number, errors?: number, info?: number,
        onChipClick?: (resultType: 'passed' | 'warnings' | 'errors' | 'info', event: React.MouseEvent) => void}) => {
    let successNumber = passed ?? 0;
    let warningsNumber = warnings ?? 0;
    let errorsNumber = errors ?? 0;
    let infoNumber = info ?? 0;
    let labelColor: 'inherit' | 'error' | 'info' | 'success' | 'warning' = 'inherit';

    if (successNumber > 0) { labelColor = 'success'; }
    if (infoNumber > 0) { labelColor = 'info'; }
    if(warningsNumber > 0) { labelColor = 'warning'; }
    if(errorsNumber > 0) { labelColor = 'error'; }

    return <>
        {noicon ?? <Box display={'inline-block'} >
            {
                alternateIcon === 1 ?
                        <ReportProblemIcon sx={{ verticalAlign: 'middle' }} color={color ?? labelColor} fontSize={labelVariant === 'large' ? 'medium' : 'small'} /> :
                <FolderIcon sx={{ verticalAlign: 'middle' }} color={color ?? labelColor} fontSize={labelVariant === 'large' ? 'medium' : 'small'} />
            }
        </Box>}
        <Typography variant={labelVariant === 'large'?'body1':'body2'} display={'inline-block'} marginLeft={5} maxWidth={'90%'}>{labelText}</Typography>
        <Box display={'inline-flex'} marginLeft={10} gap={5}>
            {successNumber > 0 && <TestingProgressIndicator label={successNumber > 999 ? '999+' : successNumber.toString()} color='success'
                onClick={onChipClick && ((event) => onChipClick('passed', event))} /> }
            {warningsNumber > 0 && <TestingProgressIndicator label={warningsNumber > 999 ? '999+' : warningsNumber.toString()} color='warning'
                onClick={onChipClick && ((event) => onChipClick('warnings', event))} />}
            {errorsNumber > 0 && <TestingProgressIndicator label={errorsNumber > 999 ? '999+' : errorsNumber.toString()} color='error'
                onClick={onChipClick && ((event) => onChipClick('errors', event))} />}
            {infoNumber > 0 && <TestingProgressIndicator label={infoNumber > 999 ? '999+' : infoNumber.toString()} color='info'
                onClick={onChipClick && ((event) => onChipClick('info', event))} />}
        </Box>
    </>
}